
import { request } from '@/store/case'
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {
      request
    }
  }
})
